import { render, staticRenderFns } from "./JobDetail.vue?vue&type=template&id=587dc5f6&scoped=true&"
import script from "./JobDetail.vue?vue&type=script&lang=js&"
export * from "./JobDetail.vue?vue&type=script&lang=js&"
import style0 from "./JobDetail.vue?vue&type=style&index=0&id=587dc5f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587dc5f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('587dc5f6')) {
      api.createRecord('587dc5f6', component.options)
    } else {
      api.reload('587dc5f6', component.options)
    }
    module.hot.accept("./JobDetail.vue?vue&type=template&id=587dc5f6&scoped=true&", function () {
      api.rerender('587dc5f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/ProvisionData/JobDetail.vue"
export default component.exports